export default __webpack_public_path__ + "static/media/courses7.352a336c.svg";